import type { JSX } from 'react'

import { IconProps, iconColor } from './IconProps'

export function NavigationUpSmallIcon(props: IconProps): JSX.Element {
  const size = props.size || 12

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 12 12'
      fill='none'
      className={props.className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.30293 7.66558C2.18644 7.79413 2.27766 7.99988 2.45113 7.99988L9.54887 7.99988C9.72234 7.99988 9.81356 7.79413 9.69707 7.66558L6.64075 4.29277C6.28688 3.90225 5.71312 3.90225 5.35925 4.29277L2.30293 7.66558Z'
        fill={iconColor(props)}
      />
    </svg>
  )
}
